import { useQuery } from '@tanstack/react-query';
import { getColocations } from '@/services/coloc-api/admin';

export const useColocations = () => {
  const query = useQuery({
    queryKey: ['colocations'] as const,
    queryFn: () => getColocations(),
    select: (data) => data.data.data,
  });

  return {
    colocations: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error,
  };
};
